import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';

// Up/down vote control. `path` is the POST endpoint. Sign-in required.
export default function VoteButtons({ path, score: s0 = 0, myVote: m0 = 0 }) {
  const { user } = useSelector((s) => s.auth);
  const navigate = useNavigate();
  const [score, setScore] = useState(s0);
  const [my, setMy] = useState(m0);
  const vote = async (dir) => {
    if (!user) return navigate('/login');
    try {
      const { data } = await client.post(path, { dir });
      setScore(data.score);
      setMy(data.myVote);
    } catch (e) { /* ignore */ }
  };
  return (
    <div className="vote">
      <button className={my === 1 ? 'voted' : ''} onClick={() => vote('up')} aria-label="Upvote">▲</button>
      <span className="vote-score">{score}</span>
      <button className={my === -1 ? 'voted' : ''} onClick={() => vote('down')} aria-label="Downvote">▼</button>
    </div>
  );
}
